module.exports = __webpack_public_path__ + "media/images/page-last-23226e47df5747fe751f9c05a01af923.svg";